if (!customElements.get('collection-page-restore')) {
  class CollectionPageRestore extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const currentPath = window.location.pathname;
      const currentPage = this.getCurrentPage();
      const urlParams = new URLSearchParams(window.location.search);
      const pageParam = urlParams.get('page');

      if (this.isCollectionPage()) {
        this.restorePageIfNeeded(currentPath, currentPage, pageParam);
        this.attachProductLinkListeners(currentPath, currentPage);
      }
    }

    isCollectionPage() {
      return document.getElementById('product-grid') !== null;
    }

    getCurrentPage() {
      const paginationWrapper = document.querySelector('.pagination-wrapper');
      if (paginationWrapper) {
        return parseInt(paginationWrapper.dataset.page) || 1;
      }
      return 1;
    }

    getStorageKey(path) {
      return `collection_page_${path.replace(/\//g, '_')}`;
    }

    restorePageIfNeeded(currentPath, currentPage, pageParam) {
      const storageKey = this.getStorageKey(currentPath);
      const savedData = sessionStorage.getItem(storageKey);

      if (savedData) {
        try {
          const { page, queryParams } = JSON.parse(savedData);
          const currentQueryParams = this.getCurrentQueryParams();

          if (parseInt(page) !== currentPage && queryParams === currentQueryParams) {
            sessionStorage.removeItem(storageKey);

            const url = new URL(window.location.href);
            url.searchParams.set('page', page);
            window.location.href = url.toString();
          } else if (queryParams !== currentQueryParams) {
            sessionStorage.removeItem(storageKey);
          }
        } catch (e) {
          sessionStorage.removeItem(storageKey);
        }
      }
    }

    getCurrentQueryParams() {
      const params = new URLSearchParams(window.location.search);
      params.delete('page');
      params.sort();
      return params.toString();
    }

    attachProductLinkListeners(currentPath, currentPage) {
      const productLinks = document.querySelectorAll('#product-grid a[href*="/products/"]');
      const storageKey = this.getStorageKey(currentPath);

      productLinks.forEach(link => {
        link.addEventListener('click', () => {
          if (currentPage > 1) {
            const queryParams = this.getCurrentQueryParams();
            const data = JSON.stringify({ page: currentPage, queryParams });
            sessionStorage.setItem(storageKey, data);
          }
        });
      });
    }
  }

  customElements.define('collection-page-restore', CollectionPageRestore);
}
